/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface HoraireSearch
 */
export interface HoraireSearch {
    /**
     * 
     * @type {number}
     * @memberof HoraireSearch
     */
    idApprenant?: number;
    /**
     * 
     * @type {TextSearch}
     * @memberof HoraireSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof HoraireSearch
     */
    jourClasse?: DateSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof HoraireSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof HoraireSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof HoraireSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof HoraireSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof HoraireSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof HoraireSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the HoraireSearch interface.
 */
export function instanceOfHoraireSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HoraireSearchFromJSON(json: any): HoraireSearch {
    return HoraireSearchFromJSONTyped(json, false);
}

export function HoraireSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoraireSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idApprenant': !exists(json, 'idApprenant') ? undefined : json['idApprenant'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'jourClasse': !exists(json, 'jourClasse') ? undefined : DateSearchFromJSON(json['jourClasse']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function HoraireSearchToJSON(value?: HoraireSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idApprenant': value.idApprenant,
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'jourClasse': DateSearchToJSON(value.jourClasse),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

